var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-8{fill:#f2f2f2;}.cls-1,.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-9{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-7,.cls-8,.cls-9{stroke-width:5px;}.cls-2{fill:#668bff;}.cls-10,.cls-2,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-9{fill:none;}.cls-4{stroke-width:2px;}.cls-10,.cls-5,.cls-6,.cls-7,.cls-8{stroke-linejoin:round;}.cls-6{stroke-width:8.23px;}.cls-10{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1055,1199l-66.55.07-88.84.1-73.36.08-70.82.08h-6l-4,0-43.53.05-57,.06-61,.07-65.48.07-42.69.05H465.9L145,1200l.65-1.64C151,1185,189.9,1092.8,251.33,1051.72c46.51-31.1,118.76-66.64,157.76-85.11l0,0c12.23-5.78,21.2-9.9,25.06-11.65,0,0,0,0,0,0l2.08-.93,72.58-.53h.48l2.77,0,2.72,0,18.58-.13,153-1.1,17.93-.13,2.14,0h0l1.76,0s0,0,0,0l17.2-.11h0l58.26-.42,1.42.5h0c4.7,1.66,20.62,7.28,42.15,15.35h0c20.59,7.69,46.3,17.6,72.27,28.34h0c27.16,11.24,54.57,23.39,76.69,34.9,24.17,12.59,42,24.4,46.19,33.4,15.49,33.37,31,125.87,32.39,134.37C1055,1198.78,1055,1199,1055,1199Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "701.9 1199.39 644.92 1199.45 613.5 1164.5 583.88 1199.52 518.4 1199.59 587.5 1082.5 642.5 1082.5 701.9 1199.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.41,949.6C472.53,949,430,1022.74,613.78,1024s151.25-80,72.5-80"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "686.45 992.68 686.45 948.92 686.45 860.52 533.41 860.52 533.41 993.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.53,915.21,531.28,944s-.66.3-1.79.87c-.6.3-1.35.69-2.21,1.16l-.12.05c-.5.27-1,.55-1.62.87h0c-1.93,1.06-4.23,2.4-6.77,4h0q-1.9,1.17-3.91,2.51c-8.89,5.92-19.21,14.28-24.88,24.07a1.62,1.62,0,0,1-.1.18,32.77,32.77,0,0,0-2.56,5.53c-.1.25-.19.5-.28.74a25.26,25.26,0,0,0-1.31,9.89h0c0,.13,0,.26,0,.4a.19.19,0,0,0,0,.08,21.61,21.61,0,0,0,.72,4s0,.06,0,.1a22.27,22.27,0,0,0,1,3.08c9.29,22.68,26.25,93.37,36.25,136.25,3.78,16.22-21.25,11.25-21.25,11.25l-26.14,49.37-.68,1.28H465.9c-.09-.42-.19-.84-.28-1.28C456.39,1155.8,430,1031.1,430,994c0-27.57,2.34-36.38,4.16-39,0,0,0,0,0,0,1.14-1.68,2.08-.93,2.08-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M523.78,1137.74s-3,.76-7.24-3c-2.59-2.29-5.61-6.29-8.64-13.22-.54-1.23-1.07-2.54-1.6-4-.42-1.12-.85-2.32-1.27-3.58-1.2-3.59-2.75-4.35-4.53-3-8.6,6.57-22.61,62.67-28.72,88.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M498.78,1110.24S460,967.74,477.53,964s55-20,55-20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.28,994c0,37.11-26.37,161.81-35.6,204.37-.08.33-.14.65-.22,1h-6l-4,0-.52-1L718.78,1149s-25,5-21.25-11.25c.52-2.25,1.07-4.59,1.63-7,0,0,0,0,0,0,.13-.53.25-1.07.38-1.62a.24.24,0,0,1,0-.08c9.93-42.28,24.89-103.74,33.67-126.18.13-.36.27-.7.41-1a0,0,0,0,1,0,0,2,2,0,0,1,.13-.31,24.15,24.15,0,0,0,1.78-11.38,2.09,2.09,0,0,0,0-.25,2,2,0,0,0,0-.25c0-.1,0-.18,0-.26-.71-6.21-3.75-12.1-8-17.42a.07.07,0,0,0,0,0c-6.4-8.1-15.49-15-23.11-19.82-3.24-2.09-6.22-3.81-8.6-5.12h0c-1-.57-2-1.05-2.74-1.47h0c-1.49-.76-2.48-1.24-2.84-1.4h0L690,944l-1.25-28.78,95,36.28s.58-.2,1.42.5h0C787.39,953.81,791.28,961.59,791.28,994Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.53,1137.74s3.21.8,7.58-3.29c0,0,0,0,0,0a34.32,34.32,0,0,0,7-10.2h0a75.16,75.16,0,0,0,3.63-8.81c.16-.46.32-.94.49-1.41,1.15-3.45,2.62-4.29,4.32-3.13,8.55,5.83,22.65,62.16,28.86,88.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.78,944s37.5,16.25,55,20-21.25,146.25-21.25,146.25-7,.46-10.37,14-15.57,13.63-12.6,4.82,37.66-131.82,35.94-139.69S723.78,955.24,688.78,944Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.06,944s-37.5,16.25-55,20,21.25,146.25,21.25,146.25,7,.46,10.36,14,15.57,13.63,12.61,4.82-37.66-131.82-35.94-139.69S497.06,955.24,532.06,944Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M826.28,966.49c33.75,23.6,0,232.76,0,232.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M899.63,995.68c20.4,17.06,0,203.48,0,203.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M976.34,1030.58c24.94,14.66,12.13,168.48,12.13,168.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M409.26,966.49c-33.75,23.6,0,232.76,0,232.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.9,1003.36c-20.39,17.06,0,195.8,0,195.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.19,1047.11c-24.93,14.66-12.13,152-12.13,152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.53,667.74c0,129.78,85.73,228,186.87,228s183.13-105.21,183.13-235-82-235-183.13-235S417.53,538,417.53,667.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 688.9,
    cy: 637.42,
    r: 15.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M604.08,671.8a28.75,28.75,0,0,0,0,57.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736.16,591.27c-14.6-31.92-40.17-44.78-77.5-31.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M472.41,591.27c14.6-31.92,40.16-44.78,77.5-31.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M662.45,826.62c-10.47,5.5-25.24,9.68-45.67,11.52-22,2-38.71,0-51-4.31-42.24-14.76-33.6-56.81-15.22-60.69,23.53-4.95,35,18.75,58.75,13.75s46.25-25,60-22.5C680.16,766.37,702,805.84,662.45,826.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M662.45,826.62c-10.47,5.5-25.24,9.68-45.67,11.52-22,2-38.71,0-51-4.31,9-15.39,28-25.81,44.78-26.94C626.3,805.84,651.76,815.38,662.45,826.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.28,710.24c-7.12-66.68,23-148.13,78.75-183.75,30-19.18,46.12-11.4,82.5-38.75C627.17,454.16,656.28,434,656.28,434s27.19,125.66,120,182.5c21.83,13.37,45.21,4.69,52.5,20,8.67,18.21-13.43,41.08-50,96.25-44,66.31-65.76,99.9-56.25,121.25,13,29.21,75.12,41.9,102.5,18.75,22.26-18.83,12.26-53.53,10-111.25-1.32-33.63.83-60.58,4.54-83.28,15-91.79,24.55-111.81,24.21-151.72-.73-83-85-142.5-118.75-153.75-17.5-85-172.92-127.55-250-81.25-48.49,29.12-35.39,74.63-121.25,167.5-42.81,46.3-59.63,79.59-75,110-56.25,111.25-23.49,232.84,67.5,285,43.85,25.14,86.94,21.37,102.5-5C485.79,820.14,429.57,788,421.28,710.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.78,716.49h21.87a48.13,48.13,0,1,0,0-96.25H783.78S788.72,684.59,783.78,716.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 734.31,
    y1: 671.35,
    x2: 759.49,
    y2: 680.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 749.31,
    y1: 656.35,
    x2: 774.49,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 471.99,
    y1: 671.35,
    x2: 446.81,
    y2: 680.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 456.99,
    y1: 656.35,
    x2: 431.81,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M755.08,379.31c-5.24-3.72-12.16-4.2-18.53-3.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M479.36,336.27c-5.78,57.36-35.62,111.91-80.79,147.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M492.81,319.18c30-23.45,71.31-33.49,112.39-13.09s44.13,52.81,66.86,78.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M653.51,316.35c12.75.88,22.92,10.79,30.7,20.93s14.86,21.5,26,27.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M741.22,409.76A136.94,136.94,0,0,1,826.74,572.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M772.63,474.27c32.84,19.92-4.16,57.69,26.55,76.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M358,521.63c-15.7,38.7-49.31,69.58-57.85,110.47a97.49,97.49,0,0,0,11.18,68.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M315.89,651.22c27.32,57.08-20.52,87.49,28.83,139.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M593,448.38a142.32,142.32,0,0,1-106.23,45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M506.26,470.08a123,123,0,0,0-34.85,8.59A73.53,73.53,0,0,0,453,489.05c-25.42,20.44-27.31,60-50.85,82.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M626.31,426.25l35-15.07a57.29,57.29,0,0,0,25.27,40.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M760.88,791.43c-7,6.78-14,13.68-18.91,22.07s-7.46,18.64-4.74,28c4,13.74,18.06,22,31.71,26.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M793.21,810.08a53.41,53.41,0,0,1-1.71,28.33,22.34,22.34,0,0,1-4.67,8.4c-6.47,6.7-18.85,4.83-24.44-2.62s-4.84-18.42.19-26.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.63,805.91a33.67,33.67,0,0,1,11.85,21.23c1,8.24-1.85,17-8,22.6-5.86,5.35-14.15,7.45-22.09,7.23-22.84-.65-43.26-21.38-43.55-44.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M401.77,724.29l16.1,56.82c2.77,9.77,5.57,19.82,4.56,29.92-.41,4-1.48,8.11-3.95,11.31s-6.56,5.37-10.55,4.72a13.46,13.46,0,0,1-6.83-3.73c-9.32-8.65-10.37-24.74-2.25-34.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M701,632c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M692.28,628.28c4.8.12,14.8-6.13,14.8-8.63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530.28,
    cy: 634.65,
    r: 15.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M518.14,629.26c-4.8.12-14.8-6.13-14.8-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M526.89,625.51c-4.8.12-14.8-6.13-14.8-8.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar03);
export default __webpack_public_path__ + "static/media/Avatar-03.b00db578e6dd3ab39e2c2edc5aa67ca3.svg";
export { ForwardRef as ReactComponent };